import { ExclusiveFilters } from '@/services/api/contracts/exclusiveFilters';
import { useExclusiveFilters } from '@/services/api/hooks/exclusiveFilters';
import { useBuildOrgTree } from '@/services/org/useBuildOrgTree';
import { useMemo } from 'react';

type GroupedFiltersByMsp = {
  [key: string]: ExclusiveFilters[];
};

export const useBuildRestrictionLabel = (productId?: string) => {
  const [filters] = useExclusiveFilters();
  const [orgTree] = useBuildOrgTree();

  return useMemo(() => {
    const productFilters = filters.filter(f => f.daasCatalogItem.id === productId && f.company);

    if (productFilters.length === 0) {
      return 'Available to all customers';
    } else if (productFilters.length === 1) {
      return `Available to ${productFilters[0].company!.name}`;
    } else {
      const filtersGroupedMyMsp = productFilters.reduce<GroupedFiltersByMsp>((result, item) => {
        if (!result[item.partner.id]) {
          result[item.partner.id] = [];
        }
        result[item.partner.id].push(item);
        return result;
      }, {});

      if (Object.keys(filtersGroupedMyMsp).length > 1) {
        return `Available to ${productFilters.length} Customers`;
      } else {
        const msp = orgTree.find(p => p.mspId === productFilters[0].partner.id);
        if (productFilters.length === msp?.customers.length) {
          return `Available to ${msp.mspName} Customers`;
        }

        return `Available to ${productFilters.length} Customers`;
      }
    }
  }, [filters]);
};
